import crs from 'country-region-selector';

$(function() {
  crs.init();
});